import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { captureAttribution } from "@/lib/attribution";

// Capture UTM / gclid on landing — must run before any form is rendered
captureAttribution();

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import Coverage from "@/components/site/Coverage";
import Process from "@/components/site/Process";
import MilitarySection from "@/components/site/MilitarySection";
import QuoteForm from "@/components/site/QuoteForm";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import PopularRoutes from "@/components/site/Routes";
import Footer from "@/components/site/Footer";

import BlogList from "@/components/site/BlogList";
import BlogPost from "@/components/site/BlogPost";

import AdminLogin from "@/components/admin/AdminLogin";
import AdminLayout, { RequireAdmin } from "@/components/admin/AdminLayout";
import AdminBlogList from "@/components/admin/AdminBlogList";
import AdminBlogEditor from "@/components/admin/AdminBlogEditor";
import AdminQuotes from "@/components/admin/AdminQuotes";
import AdminContacts from "@/components/admin/AdminContacts";

const Home = () => (
  <div className="min-h-screen bg-[#F4F4F1]">
    <Navbar />
    <main>
      <Hero />
      <QuoteForm />
      <Services />
      <WhyUs />
      <MilitarySection />
      <Process />
      <Coverage />
      <PopularRoutes />
      <Testimonials />
      <FAQ />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminBlogList />} />
            <Route path="blog" element={<AdminBlogList />} />
            <Route path="blog/new" element={<AdminBlogEditor />} />
            <Route path="blog/:id" element={<AdminBlogEditor />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="contacts" element={<AdminContacts />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "2px solid #122A1E",
            borderRadius: 0,
            background: "#F4F4F1",
            color: "#0A0E0C",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
